/**
 * Fond de carte général, partagé par l'application et le back-office.
 *
 * Les deux clients affichent le même fond : sans cela, un organisateur calerait
 * son plan sur une carte qui ne ressemble pas à celle que voient les
 * festivaliers, et jugerait son calage sur une image qui n'existe pas.
 *
 * Le schéma des couches est celui de Protomaps, dont l'archive planétaire fournit
 * les extraits.
 */

/** Identifiant de la source, à reprendre tel quel dans le style. */
export const BASEMAP_SOURCE_ID = "basemap";

/**
 * Sous-ensemble de la spécification de style MapLibre effectivement utilisé.
 *
 * Le type n'est pas importé : il vaudrait `@maplibre/maplibre-react-native` côté
 * application et `maplibre-gl` côté back-office, et ce paquet ne doit dépendre
 * d'aucun des deux. Les deux définitions sont structurellement identiques —
 * c'est la même spécification.
 */
export type BasemapLayer = {
  id: string;
  type: "fill" | "line";
  source: string;
  "source-layer": string;
  layout?: Record<string, unknown>;
  paint: Record<string, unknown>;
};

/**
 * Volontairement sobre et peu contrasté : le fond situe, le plan du festival
 * informe. Un fond trop présent rendrait les points d'intérêt plus difficiles à
 * distinguer, alors qu'ils sont ce que l'on cherche.
 */
export const BASEMAP_LAYERS: BasemapLayer[] = [
  {
    id: "basemap-earth",
    type: "fill",
    source: BASEMAP_SOURCE_ID,
    "source-layer": "earth",
    paint: { "fill-color": "#e9ecef" },
  },
  {
    id: "basemap-landuse",
    type: "fill",
    source: BASEMAP_SOURCE_ID,
    "source-layer": "landuse",
    paint: { "fill-color": "#e3e8e3" },
  },
  {
    id: "basemap-water",
    type: "fill",
    source: BASEMAP_SOURCE_ID,
    "source-layer": "water",
    paint: { "fill-color": "#c5d8e8" },
  },
  {
    id: "basemap-roads",
    type: "line",
    source: BASEMAP_SOURCE_ID,
    "source-layer": "roads",
    layout: { "line-cap": "round", "line-join": "round" },
    paint: {
      "line-color": "#ffffff",
      "line-width": ["interpolate", ["linear"], ["zoom"], 10, 0.5, 16, 4],
    },
  },
  {
    id: "basemap-buildings",
    type: "fill",
    source: BASEMAP_SOURCE_ID,
    "source-layer": "buildings",
    paint: { "fill-color": "#dfe3e6" },
  },
];
